import React from 'react'
import PropTypes from 'prop-types'
import { filterByLocation } from '../../util/filters'
import Select from 'commons/js/ui/Select'
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl'
import { Box, Copy, Icon, DotsLoader } from '@elparking/components'
import ListItem from './ListItem'
import styled from 'styled-components'
import HighlightedBlock from 'commons/js/ui/HighlightedBlock'

const getLocations = (highways) =>
    [...new Set(highways.map(({ location }) => location))]
    .map(value => ({
        value,
        label: value,
    }))

const messages = defineMessages({
    showAll: { defaultMessage: 'Ver todas las autopistas' },
    placeholder: { defaultMessage: 'Selecciona una comunidad autónoma' },
    noResults: { defaultMessage: 'Sin resultados' },
})

const ListContainer = styled(Box)`
    max-height: 480px;
    overflow-x: hidden;
    overflow-y: scroll;
`

const SelectContainer = styled(Box)`
    box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.2);
`

const RightIcon = ({ type, color }) => <Icon type={type} color={color} size='large' />

RightIcon.propTypes = {
    type: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
}

const List = ({ intl, error, highways, setLocation, location }) => {
    return (
        <Box p='1.5em 1em 0 1em'>
            <SelectContainer mb='30px'>
                <Select
                  padding='1em 0.5em'
                  arrowRenderer={() => !location && <RightIcon color='main' type='arrow-down'/>}
                  clearRenderer={() => location && <RightIcon color='gray' type='x'/>}
                  onChange={(item) => setLocation(item ? item.value : null)}
                  options={[
                    {
                        label: <i>{ intl.formatMessage(messages.showAll) }</i>,
                        value: null,
                    },
                    ...getLocations(highways),
                  ]}
                  disabled={!highways.length}
                  value={location}
                  clearable={false}
                  placeholder={intl.formatMessage(messages.placeholder)}
                  noResultsText={intl.formatMessage(messages.noResults)}
                />
            </SelectContainer>
            {error
                ? <HighlightedBlock color='red'>
                    <Copy color='white' fontSize='xxSmall' padding='0'>
                        <FormattedMessage defaultMessage='Se ha producido un error cargando la información de las autopistas' />
                    </Copy>
                </HighlightedBlock>
                : <ListContainer mt='1em'>
                    { highways.length
                       ? filterByLocation(highways, location).map((hightway) => <ListItem key={hightway.id} highway={hightway} />)
                       : <Copy textAlign='center' padding='0'>
                           <DotsLoader />
                       </Copy>
                    }
                </ListContainer>
            }
        </Box>
    )
}

List.defaultProps = {
    highways: [],
    setLocation: () => {},
    location: null,
    error: false,
}

List.propTypes = {
    error: PropTypes.bool,
    highways: PropTypes.array,
    intl: PropTypes.object,
    setLocation: PropTypes.func,
    location: PropTypes.string,
}

export default injectIntl(List)
